import styled from 'styled-components';
import ds from 'designsystem';

const CloseIcon = styled.a`
  position: absolute;
  right: 32px;
  top: 32px;
  width: 32px;
  height: 32px;
  opacity: 0.9;
  transition: opacity .3s;
  cursor: pointer;
  
  &:hover {
    opacity: 1;
  }
  
  &:before, &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: ${({ height }) => (height || '33px')};
    width: ${({ width }) => (width || '2px')};
    background-color: ${({ color }) => (color || ds.brand('text'))};
  }
  
  &:before {
    transform: rotate(45deg);
  }
  
  &:after {
    transform: rotate(-45deg);
  }
`;

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/blocks/CloseIcon/index.jsx